<template>
  <div class="map-wrap d-flex flex-column">
    <v-text-field
      dense
      class="key-field"
      label="Ключ API"
      solo
      v-model="token"
      @change="updateMap"
    ></v-text-field>
    <v-progress-linear class="loader" v-if="loading" indeterminate />
    <div id="map" />
  </div>
</template>

<script>
import api from "../api";

export default {
  name: "DemoPage",
  data() {
    return {
      map: {},
      token: this.$route.params.token || "",
      bounds: [],
      loading: false
    };
  },
  mounted() {
    window.ymaps.ready(this.initMap);
  },
  methods: {
    initMap() {
      // Создание экземпляра карты и его привязка к контейнеру с
      // заданным id ("map").
      this.map = new window.ymaps.Map(
        "map",
        {
          // При инициализации карты обязательно нужно указать
          // её центр и коэффициент масштабирования.
          center: [37.64, 55.76], // Москва
          zoom: 10
        },
        {
          searchControlProvider: "yandex#search"
        }
      );

      this.bounds = this.map.getBounds();
      this.addObjectsOnMap();

      this.map.events.add("boundschange", e => {
        this.bounds = e.get("newBounds");
        this.addObjectsOnMap();
      });
    },
    updateMap() {
      this.addObjectsOnMap();
    },
    getMapObjects(bounds) {
      this.loading = true;
      return fetch(api.points + "?token=" + this.token + "&bounds=" + bounds, {
        mode: "cors"
      }).then(resp => {
        return resp.json();
      });
    },
    getPointGoods(pointId, type) {
      this.loading = true;
      return fetch(
        api.pointsGoods + "?token=" + this.token + "&" + type + "=" + pointId,
        {
          mode: "cors"
        }
      ).then(resp => {
        return resp.json();
      });
    },
    clickPointOrPolygon(point, geoobj) {
      var text1 = point.address + "<br/>";
      if (point.type) text1 += `Тип: ${point.type}<br/>`;
      text1 += "Параметры воды:<ul>";
      for (let key in point.parameters) {
        if (point.parameters[key] !== 0)
          text1 += `<li>${key}: ${point.parameters[key]}</li>`;
      }
      text1 += "</ul>";

      var text2 = "Загрузка...";

      geoobj.properties.set({
        balloonContent: text1 + "<br>" + text2
      });

      let type = geoobj.geometry.getType() === "Polygon" ? "polygon" : "point";

      this.getPointGoods(point.id, type).then(data => {
        if (typeof data.goods !== "undefined") {
          text2 = "ID товаров партнёра: " + data.goods;
        } else {
          text2 = data.message;
        }

        geoobj.properties.set({
          balloonContent: text1 + "<br>" + text2
        });

        this.loading = false;
      });
    },
    addObjectsOnMap() {
      let bounds = JSON.stringify(this.bounds);

      this.getMapObjects(bounds).then(data => {
        // очистим карту перед добавлением новых объектов
        this.map.geoObjects.removeAll();

        // добавляем точки в массив точек
        data.points.forEach(point => {
          let placemark = new window.ymaps.Placemark(
            [point.long, point.lat],
            {
              balloonContent: point.address
            },
            {
              preset: "islands#icon",
              iconColor: "#0095b6"
            }
          );

          placemark.events.add("click", () => {
            this.clickPointOrPolygon(point, placemark);
          });

          this.map.geoObjects.add(placemark);
        });

        data.polygons.forEach(polygon => {
          let geoObject = new window.ymaps.GeoObject(
            {
              // Описываем геометрию геообъекта.
              geometry: {
                // Тип геометрии - "Многоугольник".
                type: "Polygon",
                // Указываем координаты вершин многоугольника.
                coordinates: JSON.parse(polygon.coords)
              },
              // Описываем свойства геообъекта.
              properties: {
                // Содержимое балуна.
                balloonContent: polygon.address
              }
            },
            {
              // Описываем опции геообъекта.
              // Цвет заливки.
              fillColor: polygon.color,
              // Цвет обводки.
              strokeColor: "#0000FF",
              // Общая прозрачность (как для заливки, так и для обводки).
              opacity: 0.5,
              // Ширина обводки.
              strokeWidth: 1,
              // Стиль обводки.
              strokeStyle: "solid"
            }
          );

          geoObject.events.add("click", () => {
            this.clickPointOrPolygon(polygon, geoObject);
          });

          this.map.geoObjects.add(geoObject);
        });

        this.loading = false;
      });
    }
  }
};
</script>

<style>
.container {
  height: 100%;
}
.map-wrap {
  height: 100%;
}
#map {
  width: 100%;
  flex-grow: 1;
}
.key-field {
  flex-grow: 0;
}
.loader {
  flex-grow: 0;
}
</style>
